import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useRolesApi() {
  const callApi = useApiCall();

  const getRoles = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ROLES.GET_ROLES, data, onSuccess, onError);
  };

  const getRolePermissions = (roleId: number | string, onSuccess: Function, onError: Function) => {
    const payload = { roleId };
    callApi(SAGA_ACTIONS.ROLES.GET_ROLE_PERMISSIONS, payload, onSuccess, onError);
  };

  return {
    callGetRoles: getRoles,
    callGetRolePermissions: getRolePermissions,
  };
}
